import React, { useState } from 'react';
import './App.css';
import Loader from './components/Loader/Loader';
import StartPage from './components/StartPage/StartPage';
import NavbarGame from './components/NavbarGame/NavbarGame';
import InfoPage from './components/InfoPage/InfoPage';
import InfoHolidays from './components/InfoPage/InfoHolidays';
import textContents from './data/dataInterface';
import GameFirstPage from './components/GamePage/GameFirstPage';
import Jalousie from './components/Jalousie/Jalousie';
import GamePage from './components/GamePage/GamePage';
import WellDone from './components/WellDone/WellDone';
import FinishGame from './components/FinishGame/FinishGame';
import ShowPage from './components/ShowPage/ShowPage';
import { setTimeout } from 'timers';

let imagesName = {};
let imagesArr = {};     //массив с картинками, ключ - название картинки
let rightPlace = [];    //место положение правильного ответа
let historyAnswers = [];  //история ответов 0 - не нажимали, 1 - правильно, 2 - не правильно
let langv = 'rus';
let isLoad = false;
let num = 0;
let place = [0, 1, 2, 3, 4, 5];

function newPlace(place,callback) {
    shuffle(place);
    callback();
}

function rightWrongPlace() {  //делаем случайным положение правильного ответа
    rightPlace = [];
    historyAnswers = [];

    for (let i = 0; i < imagesName.length; i++) {
        for (let j = 0; j < 3; j++) {
            newPlace(place, function () {
                rightPlace.push([place[0], place[1], place[2], place[3], place[4], place[5]]);
            })
             historyAnswers.push([0, 0, 0, 0, 0, 0]);
        }
    }
};

function GameContent(content, callback) { 
    imagesName = Object.keys(content);
  //  console.log('imagesName = ', imagesName);   

    let backgroundsName = ["bgStartRus", "bgStartFin", "bgInfo", "background", "background2", "jalousieLeft", "jalousieRight", "WellDoneFin", "WellDoneRus", "bgFinishFin", "bgFinishRus"];
    for (let id of backgroundsName) {
        imagesArr[id] = new Image(700, 650);
        imagesArr[id].src = process.env.PUBLIC_URL + '/interface/' + id + '.png';
    }
   for(let id of imagesName) {                 //чтение в кэш картинок контента, ключ - название картинки
        
        let urlFile = process.env.PUBLIC_URL +'/content/' + id + '.jpg';
        imagesArr[id] = new Image(600,380);
       imagesArr[id].src = urlFile;

       urlFile = process.env.PUBLIC_URL + '/content/' + id + '-1.jpg';
       imagesArr[id + '-1'] = new Image(270, 230);
       imagesArr[id + '-1'].src = urlFile;

     urlFile = process.env.PUBLIC_URL + '/content/' + id + '-2.png';
       imagesArr[id + '-2'] = new Image(270, 230);
       imagesArr[id + '-2'].src = urlFile; 

        urlFile = process.env.PUBLIC_URL + '/content/Names/' + id + 'Rus.png';
        imagesArr[id + 'Rus'] = new Image(550, 315);
       imagesArr[id + 'Rus'].src = urlFile;

       urlFile = process.env.PUBLIC_URL + '/content/Names/' + id + 'Fin.png';
       imagesArr[id + 'Fin'] = new Image(550, 315);
       imagesArr[id + 'Fin'].src = urlFile;
       
    }; 
 
  shuffle(imagesName);  //перемешиваем массив слов-картинок, в этом порядке будет идти текущая игра

    rightWrongPlace(); 
    callback();
};

function readData() { //чтение данных 
    let address = window.top.document.location.href; //определение языка на котором находится игра
    if (address.indexOf('/fin/') > 0) langv = 'fin';
   
    GameContent(textContents.content, function() { isLoad = true; });
 };

readData();

//Функции перемешивания масива

//вспомогательная функция
function putToCache(elem, cache){
	if(cache.indexOf(elem) !== -1){
		return;
	}
	var i = Math.floor(Math.random()*(cache.length + 1));
	cache.splice(i, 0, elem);
}
//функция, возвращающая свеженький, девственный компаратор
function madness(){
	var cache = [];
	return function(a, b){
		putToCache(a, cache);
		putToCache(b, cache);
		return cache.indexOf(b) - cache.indexOf(a);
	};
}
//собственно функция перемешивания
function shuffle(arr){
	var compare = madness();
	return arr.sort(compare);
};

  
export default function App() {
    const [isLoading, setIsLoading] = useState(false);      //окно1, признак загрузки контента
    const [isStart, setIsStart] = useState(false);          //окно2, начало игры с нуля, выбор языка
    const [isInfo, setIsInfo] = useState(false);            //окно3, инструкция к игре
    const [isNavbar, setIsNavbar] = useState(false);	    //окно4, верхнее меню
    const [isGameFirst, setIsGameFirst] = useState(false);		//окно6, игра первая страница
    const [isJalousie, setIsJalousie] = useState(false);		//окно7, ставни
    const [isGame, setIsGame] = useState(false);		    //окно8, игра вторая страница основная
    const [isWellDone, setIsWellDone] = useState(false);	//окно9, молодец 
    const [isInfoHolidays, setIsInfoHolidays] = useState(false);    //окно10, инфо о богатыре
    const [isFinish, setIsFinish] = useState(false);	    //окно11, конец игры

    const [isShow, setIsShow] = useState(false);		    //окно12, просмотр сделанного 



    const [lang, setLang] = useState(langv);
    const [step, setStep] = useState(0);
    const [curCount, setCurCount] = useState(0);            // Текущий счет 
    const [stepQuestion, setStepQuestion] = useState(-1);   //номер страницы с вопросом п.п.

    const [okStep, setOkStep] = useState(-1);                //номер последнего сделанного вопроса
    const [imgId, setImgId] = useState(1);
    const [disabledPrev, setDisabledPrev] = useState(true);  // стрелка назад отключена
    const [disabledContinue, setDisabledContinue] = useState(false);  // стрелка продолжить в истории о герое отключена

    const preloadTime = (() => {

        for (let i = 0; i < 4; i++) {
            if (num > 0) break;
            if (isLoad && num === 0) {
                setIsLoading(isLoad);
                setImgId(imagesName[0]);
                setIsStart(true);
                setStep(0);
                num++;
                break;
            }
            setTimeout(setIsLoading, 2000, isLoad);
        }
    });

    setTimeout(preloadTime, 4000);

    const startFirst = (() => {
        setStepQuestion(0);
        setCurCount(0);
        setIsJalousie(true);
        setTimeout(() => {
            setIsInfo(false);
            setIsInfoHolidays(false);
            setIsGame(false);
            setIsShow(false);
            setIsGameFirst(true);
        }, 1000)
  
        setTimeout(() => {
            setIsJalousie(false);
        }, 4000);
        setTimeout(() => {
            setIsJalousie(true);
        }, 5000);
         setTimeout(() => {
            setIsGameFirst(false);
            setIsGame(true);
            setIsNavbar(true);
        }, 6000);
        setTimeout(() => {
            setIsJalousie(false);

        }, 9000);
    })

    const handleComponent = ((pri, place) => {

        if (pri === 'rus' && lang === 'fin') {
            setLang('rus');
            langv = lang;
        };
        if (pri === 'fin' && lang === 'rus') {
            setLang('fin');
            langv = lang;
        };
        if (pri === 'start') {
            setIsStart(false);
            setIsInfo(true);
            setIsNavbar(true);
            setStep(0);
            setIsJalousie(false);
            setStepQuestion(0);
            setOkStep(-1);
            setDisabledPrev(true);
          //  startFirst();
        };
        if (pri === 'startInfo') {
            
            setCurCount(0);
            historyAnswers[(step * 3) + stepQuestion] = [0, 0, 0, 0, 0, 0];
            if (step === 0 && stepQuestion === 0) startFirst();
            else {
                setIsInfo(false);
                setIsNavbar(true);
                setIsGame(true);
            }
            
        };
        

        if (pri === 'wrong') {
            historyAnswers[(step * 3) + stepQuestion][place] = 2;
        }
        if (pri === 'answer') {
            if (historyAnswers[(step * 3) + stepQuestion][place] === 0) {
                historyAnswers[(step * 3) + stepQuestion][place] = 1;
                setCurCount(curCount + 1);
                if (curCount >= 3) {
                    setOkStep((step * 3) + stepQuestion);
                    setDisabledPrev(true);
                    setTimeout(() => {
                        setIsJalousie(true);
                    }, 2000);
                    
                    setTimeout(() => {
                        if (stepQuestion === 2) {
                            setIsWellDone(true);
                            setIsGame(false);
                            setTimeout(() => {
                                setIsJalousie(true);
                            }, 6000);
                            setTimeout(() => {
                                setIsWellDone(false);
                                setDisabledContinue(false);
                                setIsInfoHolidays(true);
                                setDisabledPrev(false);
                            }, 6500);
                            setTimeout(() => {
                                setIsJalousie(false);
                            }, 9000);
                        }
                        else {
                            setStepQuestion(stepQuestion + 1);
                            setCurCount(0);
                            setDisabledPrev(false);
                        }
                    }, 3000);
                    setTimeout(() => {
                        setIsJalousie(false);
                    }, 8000);
                }         
            }
            
        };
        if (pri === 'startNewSankarit') {
          //  setIsInfoHolidays(false);
            if (step >= (imagesName.length - 1)) {
                setIsFinish(true);
                setIsInfoHolidays(false);
            }
            else {
                setStep(step + 1);
                setImgId(imagesName[step + 1]);

                startFirst(); 
            }
             
        };

        if (pri === 'info') {
            if (curCount < 4) {
                setIsInfo(true);
                setIsGame(false);
                setIsShow(false);

                setIsFinish(false);
                setIsGameFirst(false);
            }
            if (isInfoHolidays || isInfo) {
                setIsInfoHolidays(false);
                setIsInfo(true);
                
            }
        }; 
        if (pri === 'toStart') {
            if (curCount < 4 || setIsInfoHolidays) { 
                shuffle(imagesName);
                setIsStart(true);
                setIsGame(false);
                setIsShow(false);
                setIsInfo(false);
                setIsNavbar(false);
                setIsFinish(false);
                setIsGameFirst(false);
                setIsInfoHolidays(false);
                setDisabledPrev(true);
                setImgId(imagesName[0]);
                setStep(0);
                setStepQuestion(0);
                setCurCount(0);
                rightWrongPlace();
        };
        }
        
        if (pri === 'ShowNext') {

            let curQuestion = (step * 3) + stepQuestion;
            setIsShow(true);
            if (okStep >= curQuestion) {
                if ((stepQuestion === 2)) {
                    setIsInfoHolidays(true);
                    setIsShow(false);
                    if (okStep === curQuestion) setDisabledContinue(false);
                }
                else 
                if (stepQuestion < 2) {
                    setStepQuestion(stepQuestion + 1);
                    if (okStep === curQuestion) {
                        setIsInfoHolidays(false);
                        setDisabledContinue(false);
                        setIsShow(false);
                        setIsGame(true);
                    }
                }
            }
        }; 
        if (pri === 'ShowNextHistory') {
            if (step >= (imagesName.length - 1)) {
                setIsShow(false);
                setIsFinish(true);
            }
            else {
                setStepQuestion(0);
                setStep(step + 1);
                setIsInfoHolidays(false);
                setImgId(imagesName[step + 1]);


                if (okStep === ((step * 3) + stepQuestion)) {
                    setDisabledContinue(false);
                   // setIsShow(false);
                    startFirst();
                }
                else {
                    setIsShow(true);
                }
            }
        };

        if (pri === 'prev') {
            if ((stepQuestion === 1) && (step === 0)) { 
                setDisabledPrev(true);
            }
            else setDisabledPrev(false);
            if (place === 'game') {
                historyAnswers[(step * 3) + stepQuestion] = [0, 0, 0, 0, 0, 0];
                setCurCount(0);
                setIsGame(false);
            };
            if (place === 'infoHeroes') {
                setIsInfoHolidays(false);
                setIsShow(true);
            }
            else {
                if (place === 'finish') {
                    setIsFinish(false);
                    setIsInfoHolidays(true);
                    setDisabledContinue(true);
                }
                else {
                    if (stepQuestion === 0) {
                        //были на сущесtвительных - переход на рассказ о предыдущем герое
                        setStep(step - 1);
                        setStepQuestion(2);
                        setImgId(imagesName[step - 1]);
                        setIsInfoHolidays(true);
                        setDisabledContinue(true);
                        setIsShow(false);
                    }
                    else {
                        setStepQuestion(stepQuestion - 1);
                        setIsShow(true);
                        setIsInfoHolidays(false);
                    };
                }
            };



        }; 
  
    });
    /*      
     *     {isSankarit ? <SankaritPage lang={lang} onClick={(pri) => handleComponent(pri)} textContinue={textContents.textGame.Continue[lang]} src={(lang === 'rus') ? imagesArr['bgSankaritRus'].src : imagesArr['bgSankaritFin'].src} /> : null}

 
 
         

*/
 
  return (
    <div className='App'>

          {!isLoading ? <Loader /> : null}
          {isStart ? (<StartPage lang={lang} onClick={(pri) => handleComponent(pri)} startPage={textContents.startPage} src={(lang === 'rus') ? imagesArr['bgStartRus'].src : imagesArr['bgStartFin'].src} />) : null}
          {isGameFirst ? <GameFirstPage src={imagesArr[imgId].src} nameSrc={(lang === 'rus') ? (imagesArr[imgId + 'Rus'].src) : (imagesArr[imgId + 'Fin'].src)} onClick={(pri) => handleComponent(pri)} hiddenPrev={disabledPrev} bgSrc={imagesArr['background2'].src} /> : null}

          {isGame ? <GamePage step={step} stepQuestion={stepQuestion} answers={rightPlace[(step * 3) + stepQuestion]} onClick={(pri, place, id) => handleComponent(pri, place, id)} lang={lang} src={imagesArr[imgId + '-1'].src} bgSrc={imagesArr['background'].src}  nameSrc={(lang === 'rus') ? (imagesArr[imgId + 'Rus'].src) : (imagesArr[imgId + 'Fin'].src)} textGame={textContents.content[imgId][lang].words[stepQuestion]} tasksGame={textContents.textGame.Tasks[lang]} curCount={curCount} hiddenPrev={disabledPrev} /> : null}


          {isInfo ? <InfoPage lang={lang} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} src={imagesArr['background'].src} /> : null}
          {isInfoHolidays ? <InfoHolidays lang={lang} onClick={(pri, place) => handleComponent(pri, place)} text={textContents.content[imgId][lang].text} textGame={textContents.textGame} nameSrc={(lang === 'rus') ? (imagesArr[imgId + 'Rus'].src) : (imagesArr[imgId + 'Fin'].src)} hiddenContinue={disabledContinue} src={imagesArr['background'].src} /> : null}
          {isShow ? <ShowPage step={step} stepQuestion={stepQuestion} answers={rightPlace[(step * 3) + stepQuestion]}   historyAnswers={historyAnswers[(step * 3) + stepQuestion]} onClick={(pri, place) => handleComponent(pri, place)} lang={lang} bgSrc={imagesArr['background'].src} src={imagesArr[imgId + '-1'].src} nameSrc={(lang === 'rus') ? (imagesArr[imgId + 'Rus'].src) : (imagesArr[imgId + 'Fin'].src)} textGame={textContents.content[imgId][lang].words[stepQuestion]} tasksGame={textContents.textGame.Tasks[lang]} hiddenPrev={disabledPrev} /> : null}

   
          {isNavbar ? <NavbarGame lang={lang} onClick={(pri) => handleComponent(pri)} topMenu={textContents.topMenu} /> : null}
          {isWellDone ? <WellDone lang={lang} src={imagesArr[imgId + '-2'].src} bgSrc={(lang === 'rus') ? imagesArr['WellDoneRus'].src : imagesArr['WellDoneFin'].src} /> : null}
          {isFinish ? <FinishGame lang={lang} onClick={(pri, place) => handleComponent(pri, place)} src={(lang === 'rus') ? imagesArr['bgFinishRus'].src : imagesArr['bgFinishFin'].src} /> : null}

          {isJalousie ? <Jalousie rightSrc={imagesArr['jalousieRight'].src} leftSrc={imagesArr['jalousieLeft'].src} /> : null}

       </div>
  );
};